import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=260e9830&"
import script from "./StudentInformation.vue?vue&type=script&lang=js&"
export * from "./StudentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260e9830')) {
      api.createRecord('260e9830', component.options)
    } else {
      api.reload('260e9830', component.options)
    }
    module.hot.accept("./StudentInformation.vue?vue&type=template&id=260e9830&", function () {
      api.rerender('260e9830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/studentInformation/StudentInformation.vue"
export default component.exports